import { ElementRef, Injectable, Renderer2 } from '@angular/core';
import { environment, environment_msg } from 'src/environments/environment';
import { CkEditorConfig } from '../config/ckeditor-config';
import { MeetingResponse } from '../models/basicMeetingModel';
import { AttendeeService } from './attendee.service';
import { FreeFormAgendaService } from './free-form-agenda.service';
import { Globals } from './global';
import { MeetingService } from './meeting.service';
import { UtilityService } from './utility.service';
// import * as $ from 'jquery';
import $ from 'jquery';

import { MomService } from './mom.service';
import { ConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
//UI Team change
import { NotifierService } from 'angular-notifier';
import { ImageUploadService } from './ImageUpload.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PermissionService } from './permission.service';
import { Subject } from 'rxjs/internal/Subject';
import { AgoraConfigService } from 'src/AgoraConfigService';

declare var CKEDITOR5: any;
@Injectable({
  providedIn: 'root'
})
export class FreeFormMinutesService {
  minCkEditorConfig: any;
  //UI Team change
  showCkEditor = false
  private readonly notifier!: NotifierService;
  taskStatusValue: any
  curTaskId: any;
  httpHeaders: any;
  taskStatusUpdateSource = new Subject<any>();
  taskRow$ = this.taskStatusUpdateSource.asObservable();
  agoraConfigObject: any;
  constructor(private permissionService: PermissionService, private http: HttpClient, private imageUploadService: ImageUploadService, notifierService: NotifierService, private dialog: MatDialog, private ckeditorConfigObj: CkEditorConfig, private utilService: UtilityService, private commonAgService: FreeFormAgendaService, private momService: MomService,
    private globals: Globals, private meetingService: MeetingService, private attendeeService: AttendeeService, private agoraConfig: AgoraConfigService) {
    this.agoraConfigObject = this.agoraConfig.getConfig().endpoints;
    this.minCkEditorConfig = this.ckeditorConfigObj.ckEditorConfig;
    this.notifier = notifierService;
    this.httpHeaders = new HttpHeaders()
      .set("Access-Control-Allow-Origin", "*").set("Access-Control-Allow-Headers", "Origin, X-Requested-With, Content-Type, Accept").set("Access-Control-Allow-Methods", "POST, GET, OPTIONS, DELETE, PUT");

  }

  setActivateCkEditor(bool: any) {
    this.showCkEditor = bool
  }

  returnActivateCkEditor() {
    // window.alert("called")

    return this.showCkEditor
  }

  //Method to activate ckeditor for a particular instance  
  activateCkeditor(objElem: any) {
    // Defensive guard: in CKEditor5 flow, callers may pass undefined or a non-HTMLElement
    if (!objElem || typeof objElem.getAttribute !== 'function') {
      return true;
    }
    var obj: HTMLElement = objElem;
    // If this element is already managed by Angular CKEditor5, do not attach another inline editor
    try {
      const isCk5Editable = obj.classList?.contains('ck-editor__editable');
      const isInsideCk5 = !!(obj.closest && obj.closest('.ck-editor'));
      if (isCk5Editable || isInsideCk5) {
        return true;
      }
    } catch {}
    var id: any = obj.getAttribute("id");
    if (CKEDITOR5.instances[id] == undefined) {
      var parentAgendaId: any = null;
      // this.showCkEditor == true;
      var commonMomStatusCode = document.getElementById('commonMomStatusCode')?.getAttribute('value');
      this.setActivateCkEditor(true)

      CKEDITOR5.disableAutoInline = true;
      var inlineEditor = CKEDITOR5.inline(id, this.minCkEditorConfig);
      var pageIns = this;
      var currentMinId = obj.getAttribute("minid");
      var curAgendaId = obj.getAttribute("agid");
      inlineEditor.on('key', function (event: any) {
        if (event.data.keyCode == 13) {
          var sel = window.getSelection && window.getSelection();
          var position = 0;
          var actualText = obj.innerText;
          var actualHtml = obj.innerHTML;
          var matchString = "";
          var dateMatchString = "";
          var croppedText = "";
          var lastIndexOfChar = -1;
          var additionalJson: any = {};

          var isPreNote = "";

          // const lines = (actualText.match(/\n/g) || '').length
          // if (sel && sel.rangeCount > 0) {
          //   let range: any = window.getSelection()?.getRangeAt(0);
          //   position = pageIns.utilService.getCharacterOffsetWithin(range, obj);
          // }
          // if(lines>1){
          //   ////consolee.log('position and lines'+position+","+lines);
          //   position = position+lines;
          // }
          // croppedText = actualText.substring(0, position);
          // lastIndexOfChar = croppedText.lastIndexOf("/");
          // ////consolee.log('lastIndexOfChar='+lastIndexOfChar);
          // matchString = actualText.substring(lastIndexOfChar, position);

          // if(lines>1){
          //   additionalJson.start = lastIndexOfChar-(lines-1);
          // }else{
          //   additionalJson.start = lastIndexOfChar;
          // }
          // additionalJson.end = position;
          // //
          // matchString = matchString.trim();
          const selection = inlineEditor.getSelection();
          const range = selection.getRanges()[0];
          const startNode = range.startContainer;
          if (startNode.type === CKEDITOR5.NODE_TEXT) {
            const text = startNode.getText();
            const matchResult = text.match(/(\/nn|\/dd|\/tt|\/ag|\/date|\/sg|\/agl|\/sgl|\/ddl|\/ttl|\/nnl)$/);
            if (matchResult) {
              const matchedShortcut = matchResult[0];
              const matchIndex = text.lastIndexOf(matchedShortcut);
              // Remove the shortcut
              const newText = text.substring(0, matchIndex);
              startNode.setText(newText);
              // Adjust the range to be after the removed shortcut
              range.setStart(startNode, newText.length);
              range.setEnd(startNode, newText.length);
              selection.selectRanges([range]);
              // Update matchString to the matched shortcut
              matchString = matchedShortcut;
            }
          }
          if (matchString != "" && matchString != undefined && (matchString == pageIns.globals.agendaSubCode || matchString == pageIns.globals.agendaAtLastCode) && (commonMomStatusCode != 'A')) {
            if (matchString == pageIns.globals.agendaSubCode) {
              pageIns.utilService.replaceShortcut(additionalJson, obj, pageIns.globals.agendaSubRegexCode);
            }
            parentAgendaId = curAgendaId;
            matchString = "/ag"

          }
          if (matchString != "" && matchString != undefined && (matchString == pageIns.globals.agendaCode || matchString == pageIns.globals.agendaAtLastCode) && (commonMomStatusCode != 'A') && (obj.getAttribute("parentagid") != undefined)) {
            pageIns.commonAgService.createEmptyAgendaFromMinutes('Y', parentAgendaId).then((empAgendaDetail: any) => {
              if (empAgendaDetail != null && empAgendaDetail != "" && empAgendaDetail != undefined) {
                var empAgendaId = empAgendaDetail.agendaId;
                //    //
                if (matchString == pageIns.globals.agendaCode) {
                  pageIns.utilService.replaceShortcut(additionalJson, obj, pageIns.globals.agendaRegexCode);
                } else {
                  pageIns.utilService.replaceShortcut(additionalJson, obj, pageIns.globals.agendaAtLastRegexCode);
                  empAgendaDetail.insertAtLast = "Y";
                }
                pageIns.triggerSaveMinutes(obj, event);
                pageIns.commonAgService.pushAgendaConstruction(empAgendaDetail, obj).then((result: any) => {
                  setTimeout(function () {
                    var empAgendaId = empAgendaDetail.agendaId;
                    $("#meetAgendaId" + empAgendaId).focus();
                    pageIns.commonAgService.updateAgenda($("#meetAgendaId" + curAgendaId), null, 'N');
                  }, 5);
                });
              }
            });
            //event.preventDefault();
            event.cancel();
            return false;
          }
          /*else if (matchString != "" && matchString != undefined && (matchString == pageIns.globals.agDurationCode) && pageIns.globals.editAgendaGlobalRights && (commonMomStatusCode!='A')) {
            pageIns.utilService.replaceShortcut(additionalJson, obj, pageIns.globals.agDurationRegexCode);
            if ($(obj).find(".agDurCls").length == 0) {
              var durHtml = '<span contenteditable="false" class="agDurCls"><span class="agDurLabelCls">[ </span>' + pageIns.globals.defaultAgendaDuration + '<span class="agDurLabelCls"> Minutes ]</span></span>';
              var conf = true;
         
              if ($(obj).children().last().prop("tagName") == "BR") {
                $(obj).children().last().remove();
              }
              if (conf) {
                $(obj).append(durHtml);
                pageIns.commonAgService.pushAgendaDuration(curAgendaId, pageIns.globals.defaultAgendaDuration);
                //$("#agendaMainId" + curAgendaId).attr("agendatime", this.globals.defaultAgendaDuration);
              }
            }
            pageIns.utilService.placeCaretAtEnd($(obj)[0]);
            event.preventDefault();
            return false;
          }*/
          else if (matchString != "" && matchString != undefined && ((matchString == pageIns.globals.noteCode) || (matchString == pageIns.globals.noteAtLastCode)) && pageIns.globals.addNoteGlobalRights && (commonMomStatusCode != 'A')) {
            if (matchString == pageIns.globals.noteCode) {
              additionalJson.replaceText = pageIns.globals.noteRegexCode;
              pageIns.utilService.replaceShortcut(additionalJson, obj, pageIns.globals.noteRegexCode);
            } else if (matchString == pageIns.globals.noteAtLastCode) {
              additionalJson.replaceText = pageIns.globals.noteAtLastRegexCode;
              additionalJson.insertAtLast = "Y";
            }
            pageIns.triggerSaveMinutes(obj, event);
            pageIns.commonAgService.midMinutesConstruction(event, environment.noteEntityType, obj, additionalJson);
          } else if (matchString != "" && matchString != undefined && ((matchString == pageIns.globals.decisionCode) || (matchString == pageIns.globals.decisionAtLastCode)) && pageIns.globals.addNoteGlobalRights && (commonMomStatusCode != 'A')) {

            if (matchString == pageIns.globals.decisionCode) {

              additionalJson.replaceText = pageIns.globals.decisionRegexCode;
              pageIns.utilService.replaceShortcut(additionalJson, obj, pageIns.globals.decisionRegexCode);
            } else if (matchString == pageIns.globals.decisionAtLastCode) {
              additionalJson.replaceText = pageIns.globals.decisionAtLastRegexCode;
              additionalJson.insertAtLast = "Y";
            }
            pageIns.triggerSaveMinutes(obj, event);

            pageIns.commonAgService.midMinutesConstruction(event, environment.decisionEntityType, obj, additionalJson);
          } else if (matchString != "" && matchString != undefined && ((matchString == pageIns.globals.taskCode) || (matchString == pageIns.globals.taskAtLastCode)) && pageIns.globals.addTaskGlobalRights && (commonMomStatusCode != 'A')) {

            if (matchString == pageIns.globals.taskCode) {

              additionalJson.replaceText = pageIns.globals.taskRegexCode;
              pageIns.utilService.replaceShortcut(additionalJson, obj, pageIns.globals.taskRegexCode);
            } else if (matchString == pageIns.globals.taskAtLastCode) {
              additionalJson.replaceText = pageIns.globals.taskAtLastRegexCode;
              additionalJson.insertAtLast = "Y";
            }
            pageIns.triggerSaveMinutes(obj, event);

            pageIns.commonAgService.midMinutesConstruction(event, environment.taskEntityType, obj, additionalJson);
          } else if (matchString != "" && matchString != undefined && matchString == pageIns.globals.dateCode) {
            if (obj.classList.contains("agChildTask") || obj.classList.contains("agChildDecision") || obj.classList.contains("agChildNote")) {
              pageIns.replaceDueDate(obj, obj.getAttribute("entityType"), additionalJson);
              event.cancel();
              return false;
            }
          }
        }
        if (event.data.keyCode == 2228274) { // When @ is pressed
          pageIns.commonAgService.loadTaskAssigneeAndAgPresenter(true, 'MOM', obj);
        }
        return true;
      });
      inlineEditor.on('contentDom', function () {
        var editable = inlineEditor.editable();
        editable.attachListener(editable, 'click', function (event: any) {
          event.removeListener();
          pageIns.commonAgService.noteDecisionDatepicker(inlineEditor);
          $('.minComCls').find('div[data-cke-filler-webkit]').remove();
        });
      });
      inlineEditor.on('fileUploadRequest', (evt: any) => {
        pageIns.imageUploadService.fnImageUpload(obj, inlineEditor, evt);
      });
      inlineEditor.on('fileUploadResponse', (evt: any) => {
        pageIns.imageUploadService.fnImgUploadResponse(obj, inlineEditor, evt);
        //$(".cke_dialog_close_button span").trigger("click");  

      });
      inlineEditor.on('notificationShow', function (evt: any) {
        // Do not show the default notification.
        // pageIns.imageUploadService.fnImgUploadResponse(obj,inlineEditor,evt);
        evt.cancel();
      });
      inlineEditor.on('notificationUpdate', function (evt: any) {
        // Do not show the notification even if the update was important.
        evt.cancel();
      });
      inlineEditor.on('dialogDefinition', function (evt: any) {


        evt.cancel();
      });

    } else {
      //this.setActivateCkEditor(false)
      //CKEDITOR.remove()
    }
    // this.setActivateCkEditor(false)
    return true;
  }
  sanitizePastedContent(html: string): string {
    // Remove potentially harmful tags and attributes
    const sanitizedHtml = html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
      .replace(/<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi, '')
      .replace(/ on\w+="[^"]*"/g, '');
    return sanitizedHtml;
  }
  //method to trigger common thing while initialzing minutes
  initializeMinSec(minId: any) {
    const id = "agMinId" + minId;
    let waited = 0;
    const step = 100; // ms
    const maxWait = 2000; // ms
    const tryInit = () => {
      const minElem = document.getElementById(id);
      if (minElem) {
        this.activateCkeditor(minElem);
        return;
      }
      waited += step;
      if (waited < maxWait) {
        setTimeout(tryInit, step);
      }
    };
    tryInit();
  }
  //Method to delete minutes from hover menu
  removeMinutesFromHover(divId: any, minChangeFlag: any) {

    var obj: HTMLElement = $("#" + divId)[0];

    //this.deleteMeetingMinutes(obj.getAttribute("entityType"), obj, "N",minChangeFlag);
    // if(obj.getAttribute("isFollowUpFlag")=="Y"){
    //   this.momService.deleteMinutesAttribute(serviceUrl).subscribe(res => {
    //     this.deleteMeetingMinutes(obj.getAttribute("entityType"), obj, "N",minChangeFlag);
    //   });


    // }else{
    this.deleteMeetingMinutes(obj.getAttribute("entityType"), obj, "N", minChangeFlag);
    // }
  }
  //Method to all ckeditor once
  activateAllCkeditor(minCls: any) {

    var pageIns = this;
    var noteIds: any = [];
    var elements = {};
    let objMap: Map<string, Object>;
    objMap = new Map<string, Object>();
    $('.' + minCls).each(function (index, elem) {
      var obj: HTMLElement = elem;
      var id: any = obj.getAttribute("id");
      //
      objMap.set(id, obj);
      //pageIns.activateCkeditor(elem);
    });
    objMap.forEach((value: Object, key: string) => {
      //
      pageIns.activateCkeditor(value);
      //this.setActivateCkEditor(false)
    });
    /*var myIdSet = new Set(objMap);
    noteIds = [...myIdSet];*/

  }
  //Method to delete minutes
  deleteMeetingMinutes(entityTypeCode: any, obj: HTMLElement, noalert: any, minChangeFlag: any) {

    //
    var conNoteDel = false;
    var tempMinId = obj.getAttribute("minId");
    var serviceUrl = this.getMinDeleteUrl(entityTypeCode, tempMinId);
    if (noalert != "Y") {
      if (entityTypeCode == environment.noteEntityType) {
        var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utilService.featureList.NOTES, this.utilService.permissionType.DELETE);
        if (!roleFlag) {
          return
        }
        // conNoteDel = confirm(environment_msg.msg_confirm_delete_note);
        if (minChangeFlag == "Y" && minChangeFlag != null) {
          this.momService.deleteMinutesAttribute(serviceUrl).subscribe(res => {
            if (res != null && res.body?.deleted == true) {
              this.commonAgService.popMinList(obj.getAttribute("agid"), obj.getAttribute("minid"));
              // alert("deleted successfully");
              // this.notifier.show({
              //   type: 'success',
              //   message: 'Deleted Successfully'
              // });
              this.commonAgService.updateModernMinutesSeq(obj);
            }
          });
          this.commonAgService.pushDeleteMinutes(obj.getAttribute("agid"), obj.getAttribute("minid"));
        } else {
          this.dialog.open(ConfirmDialogComponent, {
            data: {
              dialogTitle: "Confirmation",
              dialogContent: environment_msg.msg_confirm_delete_note
            },
          }).afterClosed().subscribe(response => {
            conNoteDel = response

            if (conNoteDel) {
              this.momService.deleteMinutesAttribute(serviceUrl).subscribe(res => {
                if (res != null && res.body?.deleted == true) {
                  this.commonAgService.popMinList(obj.getAttribute("agid"), obj.getAttribute("minid"));
                  // alert("deleted successfully");
                  this.notifier.show({
                    type: 'success',
                    message: 'Deleted successfully'
                  });
                  this.commonAgService.updateModernMinutesSeq(obj);
                }
              });
              this.commonAgService.pushDeleteMinutes(obj.getAttribute("agid"), obj.getAttribute("minid"));
            }
          })
        }

      } else if (entityTypeCode == environment.decisionEntityType) {
        var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utilService.featureList.NOTES, this.utilService.permissionType.DELETE);
        if (!roleFlag) {
          return
        }
        if (minChangeFlag == "Y" && minChangeFlag != null) {
          this.momService.deleteMinutesAttribute(serviceUrl).subscribe(res => {
            if (res != null && res.body?.deleted == true) {
              this.commonAgService.popMinList(obj.getAttribute("agid"), obj.getAttribute("minid"));
              // alert("deleted successfully");
              // this.notifier.show({
              //   type: 'success',
              //   message: 'Deleted Successfully'
              // });
              this.commonAgService.updateModernMinutesSeq(obj);
            }
          });
          this.commonAgService.pushDeleteMinutes(obj.getAttribute("agid"), obj.getAttribute("minid"));
        } else {
          this.dialog.open(ConfirmDialogComponent, {
            data: {
              dialogTitle: "Confirmation",
              dialogContent: environment_msg.msg_confirm_delete_decision
            },
          }).afterClosed().subscribe(response => {
            conNoteDel = response

            if (conNoteDel) {
              this.momService.deleteMinutesAttribute(serviceUrl).subscribe(res => {
                if (res != null && res.body?.deleted == true) {
                  this.commonAgService.popMinList(obj.getAttribute("agid"), obj.getAttribute("minid"));
                  // alert("deleted successfully");
                  this.notifier.show({
                    type: 'success',
                    message: 'Deleted successfully'
                  });
                  this.commonAgService.updateModernMinutesSeq(obj);
                }
              });
              this.commonAgService.pushDeleteMinutes(obj.getAttribute("agid"), obj.getAttribute("minid"));
            }
          })
        }
        // conNoteDel = confirm(environment_msg.msg_confirm_delete_decision);

      } else {

        if (minChangeFlag == "Y" && minChangeFlag != null) {
          var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utilService.featureList.TASK, this.utilService.permissionType.DELETE);
          if (!roleFlag) {
            return
          }
          this.momService.deleteMinutesAttribute(serviceUrl).subscribe(res => {
            if (res != null && res.body?.deleted == true) {
              this.commonAgService.popMinList(obj.getAttribute("agid"), obj.getAttribute("minid"));
              this.commonAgService.updateModernMinutesSeq(obj);
            }

            this.commonAgService.pushDeleteMinutes(obj.getAttribute("agid"), obj.getAttribute("minid"));
          });


        } else {
          this.dialog.open(ConfirmDialogComponent, {
            data: {
              dialogTitle: "Confirmation",
              dialogContent: environment_msg.msg_confirm_delete_task
            },
          }).afterClosed().subscribe(response => {
            conNoteDel = response

            if (conNoteDel) {



              if (obj.getAttribute("isFollowUpFlag") == "Y") {
                var curTempId = obj.getAttribute("curNoteId");
                var curServiceUrl = this.getMinDeleteUrl(environment.noteEntityType, curTempId);
                this.momService.deleteMinutesAttribute(curServiceUrl).subscribe(res => {
                  this.momService.deleteMinutesAttribute(serviceUrl).subscribe(res => {
                    if (res != null && res.body?.deleted == true) {
                      this.commonAgService.popMinList(obj.getAttribute("curAgendaId"), obj.getAttribute("curNoteId"));
                      // alert("deleted successfully");
                      // this.notifier.show({
                      //   type: 'success',
                      //   message: 'Deleted Successfully'
                      // });
                      this.commonAgService.updateModernMinutesSeq(obj);
                    }

                    this.commonAgService.pushDeleteMinutes(obj.getAttribute("curAgendaId"), obj.getAttribute("curNoteId"));
                  });
                });


              } else {
                this.momService.deleteMinutesAttribute(serviceUrl).subscribe(res => {
                  if (res != null && res.body?.deleted == true) {
                    this.commonAgService.popMinList(obj.getAttribute("agid"), obj.getAttribute("minid"));
                    this.notifier.show({
                      type: 'success',
                      message: 'Deleted successfully'
                    });
                    this.commonAgService.updateModernMinutesSeq(obj);
                  }

                  this.commonAgService.pushDeleteMinutes(obj.getAttribute("agid"), obj.getAttribute("minid"));
                });




              }



            }
          })

          // conNoteDel = confirm(environment_msg.msg_confirm_delete_task);
        }
      }
    }
    return true;
  }
  //method to destory all instance by class name
  destroyCkInstane(minCls: any) {

    $('.' + minCls).each(function (index, elem) {

      var obj: HTMLElement = elem;

      var id: any = obj.getAttribute("id");

      if (CKEDITOR5.instances[id] != undefined) {
        CKEDITOR5.instances[id].destroy();
      }
    });
  }
  //Method to replace due date
  replaceDueDate(obj: any, code: any, additionalJson: any) {
    var actualHtml = $(obj).html();
    var pageIns = this;
    if ($(obj).find('span.minDateCls').length > 0 && $(obj).hasClass("agChildTask")) {
      // this.utilService.replaceShortcut(additionalJson, obj, this.globals.dateRegexCode);
      return false;
    } else {
      // Build due-date span as DOM element to avoid extra breaks and allow caret placement
      const duedate = pageIns.utilService.curSysDate('M dd, yy');
      const dateSpan = document.createElement('span');
      dateSpan.className = 'minDateCls';
      dateSpan.setAttribute('contenteditable', 'false');
      dateSpan.setAttribute('code', String(code));
      if (code === 'AI') {
        const label = document.createElement('span');
        label.className = 'dueLabelCls';
        label.textContent = 'Due Date: ';
        dateSpan.appendChild(label);
        dateSpan.appendChild(document.createTextNode(duedate));
        if (this.globals.showTimezone_Date === 'Y') {
          const tz = document.createElement('span');
          tz.className = 'taskTimezoneCls';
          tz.textContent = ' ' + this.globals.vShortTimeZone;
          dateSpan.appendChild(tz);
        }
      } else {
        dateSpan.appendChild(document.createTextNode(duedate));
      }

      // Remove trailing <br> if present to prevent unintended new line
      try {
        const lastBrHost = document.getElementById(String($(obj).attr('id')));
        if (lastBrHost?.lastChild != null && (lastBrHost.lastChild as any).nodeName?.toUpperCase?.() === 'BR') {
          lastBrHost.removeChild(lastBrHost.lastChild);
        }
      } catch {}

      // Insert at caret if selection is inside the target element; else append to end
      let placed = false;
      try {
        const sel = window.getSelection && window.getSelection();
        if (sel && sel.rangeCount > 0) {
          const range = sel.getRangeAt(0);
          const within = (obj.contains && obj.contains(range.startContainer)) || (obj.contains && obj.contains(range.endContainer));
          if (within) {
            // Delete any selected content and insert our span + NBSP
            range.deleteContents();
            const frag = document.createDocumentFragment();
            frag.appendChild(dateSpan);
            const nbsp = document.createTextNode('\u00A0');
            frag.appendChild(nbsp);
            range.insertNode(frag);
            // Move caret after NBSP
            try {
              const after = document.createRange();
              after.setStartAfter(nbsp);
              after.setEndAfter(nbsp);
              sel.removeAllRanges();
              sel.addRange(after);
            } catch {}
            placed = true;
          }
        }
      } catch {}

      if (!placed) {
        try {
          obj.appendChild(dateSpan);
          obj.appendChild(document.createTextNode('\u00A0'));
        } catch {
          // Fallback to jQuery append if direct DOM fails
          try { $(obj).append(dateSpan); } catch {}
          try { $(obj).append('\u00A0'); } catch {}
        }
      }
      this.commonAgService.noteDecisionDatepicker(null);
      if (code == "AI") {
        this.commonAgService.updateActionItem(obj, {});
      } else {
        this.triggerSaveMinutes(obj, null);
      }
      setTimeout(function () {
        try { (obj as HTMLElement).focus(); } catch {}
        // If caret not inside obj (e.g., some browsers), place at end gracefully
        try { pageIns.utilService.placeCaretAtEnd($(obj).get(0)); } catch {}
      }, 1);
      return true;
    }
  }
  //Method to get delete url of note/decision/task
  getMinDeleteUrl(entityTypeCode: any, minId: any) {
    var meetingId = this.commonAgService.meetingResponse.meetingId;
    var serviceUrl = "";
    // var minId = obj.getAttribute("minid");

    if (entityTypeCode == environment.noteEntityType) {
      // serviceUrl = environment.deleteNoteUrl+"deleteNote" + minId;

      serviceUrl = this.agoraConfig.getConfig().apiBaseUrl + this.agoraConfigObject.note + "deleteNote/" + minId;
    } else if (entityTypeCode == environment.decisionEntityType) {
      serviceUrl = this.agoraConfig.getConfig().apiBaseUrl + this.agoraConfigObject.decision + "deleteDecision/" + minId;
    } else {
      serviceUrl = this.agoraConfig.getConfig().apiBaseUrl + this.agoraConfigObject.task + "deletetask/" + minId + "/" + meetingId;
    }
    return serviceUrl;
  }

  //Method to save from event of minutes like blur
  triggerSaveMinutes(obj: any, event: any) {

    var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utilService.featureList.MINUTES, this.utilService.permissionType.MODIFY);
    if (!roleFlag) {
      return;
    } else {

      var currentMinId = $(obj).attr("minid");
      var jsonData: any = {};
      var updatedData: any = {};
      jsonData.agendaId = $(obj).attr("agid");
      jsonData.minutesId = $(obj).attr("minid");
      jsonData.noteId = $(obj).attr("noteId");
      jsonData.decisionId = $(obj).attr("decisionId");
      jsonData.isPrivate = $(obj).attr("isprivate");
      jsonData.isDefaultNotes = $(obj).attr("isdefaultnotes");
      jsonData.noteTypeId = $(obj).attr("noteTypeId");
      jsonData.noteTypeCode = $(obj).attr("noteTypeCode");
      if (event?.which == 8) {
        if ($(obj).children('div').length > 0 && $(obj).children('div').attr("data-cke-hidden-sel") != null) {
          $(obj).find('div').remove();
        }
      }
      if ($(obj).hasClass("agChildTask") || $(obj).hasClass("agChildDecision") || $(obj).hasClass("agChildNote")) {
        var $byId = $("#agMinId" + currentMinId);
        var currentUpdateDesc = $byId.length ? $byId.html() : $(obj).html();
        // Prevent wiping newly inserted images on first upload
        const uploading = (obj as any)?.getAttribute && (obj as any).getAttribute('imgUploading') === 'Y';
        const justUploaded = (obj as any)?.getAttribute && (obj as any).getAttribute('uploadJustFinished') === 'Y';
        const hasImg = ($byId.length ? $byId.get(0) : obj)?.querySelector && ($byId.length ? $byId.get(0) : obj).querySelector('img.minImageTag, img.minutesImageAtt, img') != null;
        if (currentUpdateDesc != undefined && currentUpdateDesc == "") {
          if (!uploading && !justUploaded && !hasImg) {
            $("#agMinId" + currentMinId).html("<br/>");
          }
        }
        if ($(obj).hasClass("agChildTask")) {//code added to update Minutes(Note/decision/task) while keypress
          // if ($('.atwho-inserted:last', obj).length != 0) {
          //   var lastStr = this.utilService.removeLastString($('.atwho-inserted:last', obj).text(), ",");
          //   $('.atwho-inserted:last', obj).text(lastStr + " ");
          // }
          this.commonAgService.removeLastCommaFromConstruct(obj);


          //
          //if(this.commonAgService.presentLoad==false){
          if (this.curTaskId == jsonData.minutesId) {
            if (this.taskStatusValue != null) {
              jsonData.status = this.taskStatusValue;
            }
          }
          updatedData = this.commonAgService.updateActionItem(obj, jsonData);
          //}
          //this.commonAgService.presentLoad=false;
          // resolve(updatedData);
          //this.commonAgService.sendUpdatedActionItem(obj,jsonData);
        } else if ($(obj).hasClass("agChildDecision")) {
          this.commonAgService.updateAgendaMinutes(jsonData, environment.decisionEntityType, obj, "Y");
        } else {
          this.commonAgService.updateAgendaMinutes(jsonData, environment.noteEntityType, obj, "Y");
        }

      }
    }

  }

  initializeEditorAfterPush() {

    this.activateAllCkeditor('agChildNote');
  }

  loadOnFocus(objElem: any) {
    //
    var obj: HTMLElement = objElem;
    var id: any = obj.getAttribute("id");
    if (CKEDITOR5.instances[id] != undefined) {
      CKEDITOR5.instances[id].destroy();
    }
    this.activateCkeditor(objElem);

  }

  iterateAssignedToUpdate(actionItemOwner: any) {
    var assignedTo = "";
    actionItemOwner.forEach((element: any) => {

      assignedTo += element.fkSecUserOwner + ",";
    });

    assignedTo = this.utilService.removeLastString(assignedTo, ",");
    return assignedTo;
  }

  //used to update common task status
  updateOverAllTaskStatus(e: any, minAttrList: any, taskStatusCode: any) {
    var taskId = e.taskId;
    var meetingId = e.meetingId;
    //var taskstatus = taskStatusCode;
    var assignToUpdate = this.iterateAssignedToUpdate(e.actionItemOwner)
    var taskstatus = e.status;
    this.taskStatusValue = e.status
    this.curTaskId = e.taskId;
    var taskStatusUpdateJson = {

      "assignTo": e.assignedTo,
      "assignedToUpdate": assignToUpdate,
      "taskCommonStatus": taskstatus,
      // "taskCommonStatus": e.status,
      "taskFinishDate": e.dueDate,
      "notes": e.noteDescription,
      "meetingId": e.meetingId,
      //"actionItemId": minAttrList.taskId,
      "meetingTitle": e.meetingTitle,
      "actionItemTitle": e.taskTitle,
      "entityId": e.agendaId,
      //"newactifonItemOwner": "",
      "createdOn": e.createdOn,
      "prevLastModifiedOn": "",
      //"noDirtyCommit": "Y",
      "isPrivate": e.isPrivate,
      //"movingToAgendaId": "",
      //"fromDragAndDrop": "",
      //"fromContextMenu": "",
      "noteTypeId": e.noteTypeId,
      "noteTypeCode": e.noteTypeCode,
      "taskId": e.taskId,
      "projectId": ""
    }
    //
    //
    this.meetingService.updateCommonTaskStatus(taskId, meetingId, taskstatus, taskStatusUpdateJson).subscribe(responsedata => {
      //
      this.taskStatusUpdateSource.next({ taskVal: responsedata.body });
    });

  }


}
